import { Alert, AlertTitle } from '@repo/ui';
import cn from 'clsx';

import s from './Notice.module.scss';

import { useNotice } from '@/lib/hooks/api/query/use-notice';

const Notice = () => {
  const notice = useNotice();

  if (notice?.result && notice?.contents?.length && notice?.contents?.length > 0) {
    return (
      <div className={'notice-container container-medium container-padding-medium mx-auto w-full mb-normal-small'}>
        <div className={cn('bg-yellow-100 w-full px-normal-medium py-normal-small rounded-bzc-small', s.wrap)}>
          <Alert
            className={'flex justify-center gap-tiny-medium !p-0'}
            graphic={<img src={`${process.env.NEXT_PUBLIC_RESOURCE_CENTER_URL}/common/iconography/icg_exclamation-mark_sm.svg`} className={'w-6'} alt={''} />}
            variant="custom"
            size="small"
          >
            <AlertTitle className="break-all text-neutral-foreground-main body-small-regular">{notice.contents}</AlertTitle>
          </Alert>
        </div>
      </div>
    );
  }

  return <></>;
};

export default Notice;
